import { REDUCER_NAME } from "./consts";

export const selectors = {
  selectIsOpen: (state) => state[REDUCER_NAME]?.isOpen,
};
